import { render } from "./CreateNetworkPermission.vue?vue&type=template&id=3374b1b8&scoped=true"
import script from "./CreateNetworkPermission.vue?vue&type=script&lang=js"
export * from "./CreateNetworkPermission.vue?vue&type=script&lang=js"

import "./CreateNetworkPermission.vue?vue&type=style&index=0&id=3374b1b8&lang=less&scoped=true"

import exportComponent from "/jenkins/workspace/acs-centos8-pkg-builder/dist/rpmbuild/BUILD/cloudstack-4.20.1.0/ui/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3374b1b8"]])

export default __exports__